import { apiPropsBuilder as apiBuilder } from './api';
import { graphPropsBuilder as graphBuilder } from './graph';

export const apiCallProps = (api = {}, args) => {
  const { graph } = api;

  return graph ? graphBuilder(api, args) : apiBuilder(api, args);
};
